/**
 * Shared Precision Custom Smart Stack cart helpers.
 * Used by reveal approve + Guide agent bridge so Approve is replace-not-append.
 *
 * Match stack lines by product identity / SKU / stack selling plan / private
 * line props — never by price or title.
 */
(function (global) {
  'use strict';

  var PRECISION_STACK_PRODUCT_ID = 9195256479994;
  var PRECISION_STACK_HANDLE = 'monthlees-custom-smart-stack-monthly';
  var PRECISION_STACK_SKU_PREFIX = 'PSS-SMARTSTACK';
  var DEFAULT_STACK_SELLING_PLAN_ID = 6413320442;

  function normalizeId(value) {
    if (value == null || value === '') return 0;
    var m = /(\d+)\s*$/.exec(String(value));
    return m ? Number(m[1]) : 0;
  }

  function readSku(item) {
    if (!item) return '';
    if (item.sku) return String(item.sku);
    if (item.variant && item.variant.sku) return String(item.variant.sku);
    return '';
  }

  function readHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    if (item.url) {
      var m = /\/products\/([^/?#]+)/.exec(String(item.url));
      if (m) return m[1];
    }
    return '';
  }

  function lineSellingPlanId(item) {
    if (!item) return 0;
    var allocation = item.selling_plan_allocation;
    if (allocation && allocation.selling_plan) {
      return normalizeId(allocation.selling_plan.id);
    }
    if (item.selling_plan) return normalizeId(item.selling_plan);
    return 0;
  }

  /**
   * @param {object} item - Shopify cart line from /cart.js
   * @param {object} [opts]
   * @param {string|number} [opts.stackSellingPlanId]
   */
  function isPrecisionStackLine(item, opts) {
    if (!item) return false;
    opts = opts || {};

    var productId = normalizeId(item.product_id || (item.product && item.product.id));
    if (productId && productId === PRECISION_STACK_PRODUCT_ID) return true;

    var handle = readHandle(item).toLowerCase();
    if (handle === PRECISION_STACK_HANDLE) return true;

    var sku = readSku(item).toUpperCase();
    if (sku.indexOf(PRECISION_STACK_SKU_PREFIX) === 0) return true;

    var props = item.properties || {};
    // Private props (preferred) + legacy customer-visible result_id from older adds.
    if (props._pack_id || props._result_id || props.result_id) return true;

    var stackPlanId =
      normalizeId(opts.stackSellingPlanId) || DEFAULT_STACK_SELLING_PLAN_ID;
    var planId = lineSellingPlanId(item);
    if (stackPlanId && planId && planId === stackPlanId) return true;

    return false;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    });
  }

  function changeCartLineQuantity(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart line update failed');
      return res.json();
    });
  }

  /**
   * Remove every existing Precision stack subscription so Approve REPLACES.
   * Non-Precision lines are untouched.
   */
  function removeExistingPrecisionStacks(opts) {
    opts = opts || {};
    return fetchCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var keys = [];
      for (var i = 0; i < items.length; i += 1) {
        if (isPrecisionStackLine(items[i], opts) && items[i].key) {
          keys.push(items[i].key);
        }
      }
      if (!keys.length) return cart;

      return keys.reduce(function (chain, key) {
        return chain.then(function () {
          return changeCartLineQuantity(key, 0);
        });
      }, Promise.resolve());
    });
  }

  global.MonthleesPrecisionStackCart = {
    PRECISION_STACK_PRODUCT_ID: PRECISION_STACK_PRODUCT_ID,
    PRECISION_STACK_HANDLE: PRECISION_STACK_HANDLE,
    DEFAULT_STACK_SELLING_PLAN_ID: DEFAULT_STACK_SELLING_PLAN_ID,
    normalizeId: normalizeId,
    isPrecisionStackLine: isPrecisionStackLine,
    removeExistingPrecisionStacks: removeExistingPrecisionStacks,
    fetchCart: fetchCart,
  };
})(typeof window !== 'undefined' ? window : this);
